module.exports = __webpack_public_path__ + "static/img/swiperadmin2.cb4b080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin2.png
// module id = QqiN
// module chunks = 1